import {Button, Modal, ModalContent, ModalFooter, ModalTitle, TextRegular} from '@hm/fundamental'
import React from 'react'

import {useTranslation} from '../../../hooks/useTranslation'

type ResetPasswordDialogProps = {
  showResetPasswordDialog: boolean
  setShowResetPasswordDialog: (show: boolean) => void
  handleResetPassword: () => Promise<void>
}
export const ResetPasswordDialog = ({
  setShowResetPasswordDialog,
  showResetPasswordDialog,
  handleResetPassword
}: ResetPasswordDialogProps) => {
  const {t} = useTranslation()

  return (
    <Modal
      open={showResetPasswordDialog}
      onClose={() => setShowResetPasswordDialog(false)}
      data-test-id="manage-user-dialog-reset-password"
    >
      <ModalTitle>{t('manageUser.resetPasswordDialogTitle')}</ModalTitle>
      <ModalContent>
        <TextRegular> {t('manageUser.resetPasswordDialogMessage')}</TextRegular>
      </ModalContent>
      <ModalFooter>
        <Button
          size="large"
          variant="tertiary"
          onClick={() => setShowResetPasswordDialog(false)}
          type="button"
        >
          {t('manageUser.resetPasswordDialogActionCancel')}
        </Button>
        <Button
          size="large"
          onClick={handleResetPassword}
          data-test-id="button-reset-password-confirm"
          type="button"
        >
          {t('manageUser.resetPasswordDialogActionOk')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
